import { ToastEventBus, ToastMessageOptions } from 'primevue'
import { useLocalStorage } from '@vueuse/core'

const defaultToastOptions: ToastMessageOptions = {
  life: 5000,
  closable: true,
}

const getToastRef = () => {
  const toastRef = useLocalStorage<Date[]>('toastCount', [])

  const now = new Date()

  toastRef.value = toastRef.value.filter((date) => {
    return new Date(date).getTime() > now.getTime() - 60 * 1000
  })

  return toastRef
}

const incrementToastCount = () => {
  const toastRef = getToastRef()

  toastRef.value.push(new Date())
}

export type ToastType = ReturnType<typeof useToast>

/**
 * A composable function to show toast messages. Since toast is an vue provide / inject, we have to use this otherwise it will throw an error
 */
export function useToast() {
  const add = (options: ToastMessageOptions) => {
    if (getToastRef().value.length > 5) {
      return
    }

    ToastEventBus.emit('add', options)

    incrementToastCount()
  }
  const error = (summary: string, detail?: string) => add({
    summary: summary,
    detail: detail,
    severity: 'error',
    ...defaultToastOptions,
  })

  const success = (summary: string, detail?: string) => add({
    summary: summary,
    detail: detail,
    severity: 'success',
    ...defaultToastOptions,
  })

  const warn = (summary: string, detail?: string) => add({
    summary: summary,
    detail: detail,
    severity: 'warn',
    ...defaultToastOptions,
  })

  const info = (summary: string, detail?: string) => add({
    summary: summary,
    detail: detail,
    severity: 'info',
    ...defaultToastOptions,
  })

  return {
    add,
    error,
    success,
    warn,
    info,
  }
}
